import React from 'react'
import {Container} from "react-bootstrap";
import LocalizedStrings from "react-localization";
import {DEFAULT_LANGUAGE, COMPANY_NAME} from "./App";
import './css/Footer.css';

function Footer() {
    let localizedGeneralInfos = new LocalizedStrings({
        vn: {
            termsAndConditions: 'Điều kiện hợp đồng',
            technicalSupport: 'Hỗ trợ kĩ thuật',
            contacts: 'Liên hệ',
            tagline: 'Bất động sản Séc',
            allRights: 'Bảo lưu mọi quyền.',
            bilingual: 'Nền tảng song ngữ',
            privacyPolicy: 'Chính sách bảo mật',
            personData: 'Bảo vệ dữ liệu cá nhân',
            brokerTerms: 'Điều kiện môi giới',
            complaints: 'Khiếu nại',
            cookieSettings: 'Cài đặt cookie',
            searchTitle: 'Tìm kiếm',
            buyApt: 'Mua căn hộ', rentApt: 'Thuê căn hộ',
            buyHouse: 'Mua nhà', rentHouse: 'Thuê nhà',
            buyLand: 'Mua đất', commercial: 'Thương mại',
            allEstate: 'Tất cả bất động sản',
        },
        cz: {
            termsAndConditions: 'Smluvní podmínky',
            technicalSupport: 'Technická podpora',
            contacts: 'Kontakty',
            tagline: 'České nemovitosti',
            allRights: 'Všechna práva vyhrazena.',
            bilingual: 'Dvojjazyčná platforma',
            privacyPolicy: 'Zásady ochrany soukromí',
            personData: 'Ochrana osobních údajů',
            brokerTerms: 'Zprostředkovatelské podmínky',
            complaints: 'Reklamace',
            cookieSettings: 'Nastavení cookie',
            searchTitle: 'Hledání',
            buyApt: 'Koupit byt', rentApt: 'Pronájem bytu',
            buyHouse: 'Koupit dům', rentHouse: 'Pronájem domu',
            buyLand: 'Koupit pozemek', commercial: 'Komerční',
            allEstate: 'Všechny nemovitosti',
        }
    });

    const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : DEFAULT_LANGUAGE;
    localizedGeneralInfos.setLanguage(lang);

    return (
        <footer className="footer-root">
            <Container>
                <div className="footer-main">

                    {/* Left: brand + contact */}
                    <div className="footer-brand">
                        <a href="/" className="footer-logo-link">
                            <picture>
                                <source srcSet="/static/images/logo.webp" type="image/webp" />
                                <img src="/static/images/logo.png" alt="Prahanoi" className="footer-logo" width="69" height="40" />
                            </picture>
                        </a>
                        <div className="footer-brand-info">
                            <p className="footer-tagline">{localizedGeneralInfos.tagline}</p>
                            <div className="footer-flags">
                                <img src="/static/images/czech_flag.svg" alt="Česky" width="24" height="17" title="Česky" />
                                <img src="/static/images/vietnam_flag.svg" alt="Tiếng Việt" width="24" height="17" title="Tiếng Việt" />
                                <span className="footer-bilingual">{localizedGeneralInfos.bilingual}</span>
                            </div>
                            <a
                                href="https://www.facebook.com/profile.php?id=61593315153665"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-fb-link share-btn share-btn--facebook"
                                title="Facebook"
                                aria-label="Prahanoi na Facebooku"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Centre: category SEO links */}
                    <div className="footer-search-links">
                        <strong className="footer-links-title">{localizedGeneralInfos.searchTitle}</strong>
                        <nav className="footer-links">
                            <a href="/tim-kiem/can-ho/ban/">{localizedGeneralInfos.buyApt}</a>
                            <a href="/tim-kiem/can-ho/thue/">{localizedGeneralInfos.rentApt}</a>
                            <a href="/tim-kiem/nha/ban/">{localizedGeneralInfos.buyHouse}</a>
                            <a href="/tim-kiem/nha/thue/">{localizedGeneralInfos.rentHouse}</a>
                            <a href="/tim-kiem/dat/ban/">{localizedGeneralInfos.buyLand}</a>
                            <a href="/tim-kiem/thuong-mai/">{localizedGeneralInfos.commercial}</a>
                            <a href="/tim-kiem/">{localizedGeneralInfos.allEstate}</a>
                        </nav>
                    </div>

                    {/* Right: legal links */}
                    <div className="footer-right">
                        <nav className="footer-links">
                            <a href="/contacts/">{localizedGeneralInfos.contacts}</a>
                            <a href="/technical-support/">{localizedGeneralInfos.technicalSupport}</a>
                            <a href="/terms-and-conditions/">{localizedGeneralInfos.termsAndConditions}</a>
                            <a href="/broker-terms/">{localizedGeneralInfos.brokerTerms}</a>
                            <a href="/privacy-policy/">{localizedGeneralInfos.privacyPolicy}</a>
                            <a href="/complaints/">{localizedGeneralInfos.complaints}</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); window.__ucCmp?.showSecondLayer(); }}>{localizedGeneralInfos.cookieSettings}</a>
                        </nav>
                    </div>

                </div>

                <div className="footer-bottom">
                    <span>© {new Date().getFullYear()} {COMPANY_NAME}. {localizedGeneralInfos.allRights}</span>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
